export default function partnerWidget() {
  const widgetName = 'partnerWidget';
  const widgetOpts = partnerWidgetOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: 'all',
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createPartner(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function createPartner(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];

      const $ad = $(this);

      $ad.find('.card-content').remove();
      $ad.attr('aria-label', Title);

      if (!URL) {
        $ad.addClass('empty-card').removeAttr('href');
      }
    });
  }
}
